<template>
  <div
    class="map-picker"
    :class="{ active: this.isInvalidateSize }"
    :style="{ height: height }"
  >
    <l-map ref="map" :center="center" :zoom="zoom" @click="onClickMap">
      <l-tile-layer :url="tileLayer.url" :attribution="tileLayer.attribution"
    /></l-map>
  </div>
</template>

<script>
import { marker } from "leaflet";

export default {
  props: {
    height: {
      type: String,
      default: "300px",
    },
    latitude: {
      type: Number,
      default: 40.52,
    },
    longitude: {
      type: Number,
      default: 34.34,
    },
    zoom: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    center() {
      return [this.latitude, this.longitude];
    },
  },
  data() {
    return {
      isInvalidateSize: false,
      tileLayer: {
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      marker: null,
    };
  },
  mounted() {
    this.invalidateSize();
  },
  methods: {
    onClickMap(e) {
      const { latlng } = e;
      this.createMarker(latlng);
    },
    createMarker(latlng) {
      const map = this.$refs.map.mapObject;
      if (this.marker) {
        map.removeLayer(this.marker);
        this.marker = null;
      }
      this.marker = new marker(latlng).addTo(map);
      this.$emit("change", {
        latitude: latlng.lat,
        longitude: latlng.lng,
      });
    },
    invalidateSize() {
      const map = this.$refs.map.mapObject;
      setTimeout(() => {
        map.invalidateSize();
        this.isInvalidateSize = true;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.map-picker {
  width: 100%;
  min-height: 100px;
  visibility: hidden;

  &.active {
    visibility: visible;
  }

  .vue2leaflet-map {
    width: 100%;
    height: 100%;
  }
}
</style>